import React, { useContext, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { ActionMeta, components } from "react-select";
import MinimalSelect from "./MinimalSelect";
import axios from "axios";
import styled from "styled-components";
type Props = {
  required: boolean;
  selectedView: {
    label: string;
    value: number;
  };
  setSelectedView: any;
};
const CategorySelect = (props: Props) => {
  React.useEffect(() => {
    categoryFetch();
  }, []);

  const screenClass = useScreenClass();
  const [viewOptions, setViewOptions] = useState<
    Array<{ label: string; value: number }>
  >([]);
  const { selectedView, setSelectedView } = props;
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const categoryOption: { label: string; value: number; color: string }[] = [];
  const StyledOption = styled("div")`
    width: 10px;
    height: 10px;
    background: ${(props: any) => props?.color || "red"};
    box-shadow: 0 3px 5px gray;
    border-radius: 50%;
    margin-right: 10px; // Adjust spacing as needed
  `;
  const categoryFetch = () => {
    axios
      .get(`/announcement_category`)
      .then((res) => {
        console.log(res.data.announcement_categories);
        categoryOption.length === 0 &&
          res.data.announcementCategories?.map((v: any) =>
            categoryOption.push({
              label: v.title,
              value: v.id,
              color: v.color,
            })
          );
        setViewOptions(categoryOption);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log(selectedView);
  const { Option } = components;

  const CustomOption = (props: any) => (
    <Option {...props}>
      <div style={{ display: "flex", alignItems: "center", height: 20 }}>
        <StyledOption color={props.data.color}></StyledOption>
        {props.label}
      </div>
    </Option>
  );

  return (
    <>
      <MinimalSelect
        required
        setClass={isMobile ? "rs-container" : "custom-container"}
        placeholder="Select Category"
        options={viewOptions}
        value={viewOptions.find((v: any) => v.label === selectedView)}
        onChange={(newValue: any, actionMeta: ActionMeta<unknown>) => {
          setSelectedView(newValue);
        }}
        components={{
          Option: CustomOption, // Use the custom option component
        }}
      />
    </>
  );
};

export default CategorySelect;
